import React from 'react';

import { di } from 'react-magnetic-di';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield/text-field';

import { asFormTextField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

const previewStyles = xcss({
	maxWidth: '240px',
});

export const PreviewTextShortInput = ({
	fieldId,
	fieldInputId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);

	const formField = useFormField({ fieldId });
	const formTextField = asFormTextField(formField);

	if (formTextField === undefined) {
		return <></>;
	}

	return (
		<Box testId={`field-input-text-short-preview-${fieldId}`} xcss={previewStyles}>
			<Textfield value={formTextField.value?.text} isDisabled id={fieldInputId} width="small" />
		</Box>
	);
};
